import React, { FC, ReactElement } from 'react'
import TextInput, { TextInputProps } from '../../../../React/Common/Components/TextInput/TextInput'

export const OutlinedTextInput: FC<TextInputProps> = (props: TextInputProps): ReactElement => (
    <TextInput {...props} containerClassName={`${props.containerClassName} outlined-text-input`} variant='outlined' />
)
